import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { globalVariant } from '../../types';
import JssProvider from 'react-jss/lib/JssProvider';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/styles/';
var generateClassName = createGenerateClassName();
var insertionPoint = typeof document !== 'undefined' ? document.getElementById('jss-insertion-point') : null;
var jss = create(_objectSpread({}, jssPreset(), {
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: insertionPoint
}));

/* Context */
var ThemeContext = React.createContext();
/**
 * Global theme variant provider
 *
 **/

var ThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ThemeProvider, _React$Component);

  function ThemeProvider(props) {
    var _this;

    _classCallCheck(this, ThemeProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeProvider).call(this, props));

    _this.setVariant = function (variant) {
      _this.setState({
        variant: variant
      });
    };

    _this.state = {
      variant: _this.props.variant,
      subvariant: _this.props.subvariant || '',
      muiTheme: createMuiTheme({
        palette: {
          primary: {
            main: '#022c49'
          },
          secondary: {
            main: '#23afe4',
            contrastText: 'white'
          }
        },
        typography: {
          fontFamily: '"Open Sans", sans-serif',
          useNextVariants: true
        }
      })
    };
    return _this;
  }
  /**
   * Sets the theme variant
   * @param {globalVariant} variant The variant
   **/


  _createClass(ThemeProvider, [{
    key: "render",
    value: function render() {
      var disableStylesGeneration = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
      return React.createElement(JssProvider, {
        jss: jss,
        generateClassName: generateClassName,
        disableStylesGeneration: disableStylesGeneration
      }, React.createElement(MuiThemeProvider, {
        theme: this.state.muiTheme,
        disableStylesGeneration: disableStylesGeneration
      }, React.createElement(ThemeContext.Provider, {
        value: this.state
      }, this.props.children)));
    }
  }]);

  return ThemeProvider;
}(React.Component);

ThemeProvider.defaultProps = {
  variant: 'pc'
  /**
   * The consumer component for the ThemeContext
   **/

};
export var ThemeConsumer = ThemeContext.Consumer;
/**
 * HOC that provides the globalVariant Prop
 */

export var withThemeVariant = function withThemeVariant(Component) {
  return function (props) {
    return React.createElement(ThemeConsumer, null, // Components can be used without provider. HOC needs to be nullsave
    function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return React.createElement(Component, Object.assign({
        globalThemeVariant: state.variant,
        globalThemeSubVariant: state.subvariant
      }, props));
    });
  };
};
export default ThemeProvider;